import { Icon } from '@iconify/react/dist/iconify.js'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import { addNewSubCategory, getCategoriesApi } from '../../apiHelper/authService'
import { useSelector } from 'react-redux'
import toast from 'react-hot-toast'
import { clearSelectedSubCategory } from '../../redux/authModalSlice'
const AddNewSubCategory = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    let { user } = useSelector(state => state.authModal)
    const { selectedSubCategory } = useSelector((state) => state.authModal);
    const [parentCategories, setParentCategories] = useState()
    const [loading, setLoading] = useState(false)
    const [categoryName, setCategoryName] = useState('');
    const [categoryId, setCategoryId] = useState('');
    const [selectedParentCategory, setSelectedParentCategory] = useState(null);
    const [selectedParentCategoryName, setSelectedParentCategoryName] = useState(null);
    const [mailImage, setMailImage] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);

    //   const quillRef = useRef();
    const [imageName, setImageName] = useState('');
    const [selectedParentCategoryId, setSelectedParentCategoryId] = useState(null);


    const [isPublished, setIsPublished] = useState(false);

    const fromCountry = user?.from;
    const toCountry = user?.to;

    console.log(selectedParentCategory)


    const handleChangeParent = (category) => {
        setSelectedParentCategory(category)
        setSelectedParentCategoryName(category?.name)
        setSelectedParentCategoryId(category?.id)

    }

    // console.log(selectedParentCategory)



    const handleAddNewSubCategory = async () => {


        if (!categoryName) {
            toast.error("Enter Name of Sub Category")
            return
        }

        if (!selectedParentCategoryId) {
            toast.error("Can not create subcategory without parent category")
            return
        }


        if (!imagePreview) {
            toast.error("Image is required");
            return;
        }
        setLoading(true);



        const formData = new FormData();
        formData.append('isActive', isPublished);
        formData.append('id', categoryId);
        formData.append('from', fromCountry);
        formData.append('to', toCountry);
        formData.append('name', categoryName);
        formData.append('parentCategoryId', selectedParentCategoryId);





        if (mailImage) {
            formData.append('categoryImage', mailImage);
        }



        const toastId = toast.loading("Creating Sub Category...");

        try {
            const data = await addNewSubCategory(formData);
            // setCategories(data);
            toast.success("Sub Category created successfully!", { id: toastId });
            navigate("/sub-categories")

        } catch (err) {
            console.error("Fetch Error:", err);

            toast.error(
                err || "Something went wrong while creating sub category.",
                { id: toastId }
            );
        } finally {
            setLoading(false);
        }
    };


    const getCategoriesData = async () => {
        setLoading(true);



        // const toastId = toast.loading("Fetching Categories...");

        try {
            const data = await getCategoriesApi({ from: fromCountry, to: toCountry });
            setParentCategories(data);
            toast.success("Categories fetched successfully!");
        } catch (err) {
            console.error("Fetch Error:", err);

            toast.error(
                err?.message || "Something went wrong while fetching sub categories.",
            
            );
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {

        getCategoriesData()


    }, [])

    // console.log(parentCategories)

    useEffect(() => {
        if (selectedSubCategory) {
            setCategoryName(selectedSubCategory.name || '');
            setIsPublished(selectedSubCategory.isActive || false);
            setCategoryId(selectedSubCategory?.id || '')
            setSelectedParentCategoryName(selectedSubCategory?.parent_category?.name || '')
            setSelectedParentCategoryId(selectedSubCategory?.parent_category_id || '')


            
            if (selectedSubCategory?.image_url) {
                setImagePreview(selectedSubCategory.image_url);
                const imageName = selectedSubCategory.image_url
                setImageName(imageName);
                setMailImage(selectedSubCategory?.image_url)
            } else {
                setImagePreview(null);
                setImageName('');
                setMailImage('')
            }

        }

        return () => {
            // Clear Redux state when navigating away
            dispatch(clearSelectedSubCategory());
        };
    }, [selectedSubCategory, dispatch]);
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file && file.type.startsWith('image/')) {
            setMailImage(file);

            setImagePreview(URL.createObjectURL(file));
            setImageName(file.name);
        } else {
            alert('Please upload a valid image file');
        }
    };

    const handleRemoveImage = () => {
        setMailImage(null);

        setImagePreview(null);
        setImageName('');
    };


    return (
        <div className="col-md-12 ">
            <div className="card">
                <div className="card-header">
                    <h5 className="card-title mb-0">Basic Information</h5>
                </div>
                <div className="card-body">
                    <div className="row gy-4">
                        <div className="col-12">
                            <label className="form-label">Sub Category Name</label>
                            <div className="icon-field">
                                <span className="icon">
                                    <Icon icon="mdi:shape-outline" />
                                </span>
                                <input
                                    type="text"
                                    name="categoryName"
                                    value={categoryName}
                                    onChange={(e) => setCategoryName(e.target.value)}
                                    className="form-control"
                                    // placeholder="Enter Category Name"
                                    placeholder="Enter Sub Category Name"
                                />
                            </div>
                        </div>
                        <div className="col-12">

                            <div className="form-switch switch-primary d-flex align-items-center gap-3">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="horizontal1"
                                    checked={isPublished}
                                    onChange={(e) => setIsPublished(e.target.checked)}
                                />
                                <label
                                    className="form-check-label line-height-1 fw-medium text-secondary-light"
                                    htmlFor="horizontal1"
                                >
                                    Publish
                                </label>
                            </div>
                        </div>

                        <div className="dropdown">
                            <button
                                className="btn btn-primary-600 bg-primary-50 border-primary-50 text-primary-600 hover-text-primary not-active px-18 py-11 dropdown-toggle toggle-icon"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                {" "}
                                {selectedParentCategoryName || "Select Parent Category"}{" "}
                            </button>
                            <ul className="dropdown-menu">
                                {parentCategories?.map((category) => (
                                    <li key={category.id}>
                                        <button
                                            type="button"
                                            className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                            onClick={() => handleChangeParent(category)}
                                        >
                                            {category?.name}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>


                        <div className="col-12 col-md-6">
                            <label className='form-label fw-bold text-neutral-900'>
                                Sub Category Image
                            </label>
                            <div className='upload-image-wrapper'>
                                {imagePreview ? (
                                    <div className='uploaded-msg-wrapper h-160-px w-100 border input-form-light radius-8 overflow-hidden border-dashed bg-success-50 d-flex justify-content-between align-items-center px-3'>
                                        <div>
                                            <p className='mb-1 fw-semibold text-success-700'>Image uploaded successfully</p>
                                            <p className='mb-0 text-sm text-neutral-700'>{imageName}</p>
                                        </div>
                                        <button
                                            type='button'
                                            className='btn btn-sm btn-danger ms-3'
                                            onClick={handleRemoveImage}
                                        >
                                            Remove
                                        </button>
                                    </div>
                                ) : (
                                    <label
                                        className='upload-file h-160-px w-100 border input-form-light radius-8 overflow-hidden border-dashed bg-neutral-50 bg-hover-neutral-200 d-flex align-items-center flex-column justify-content-center gap-1 cursor-pointer'
                                        htmlFor='upload-file'
                                    >
                                        <iconify-icon
                                            icon='solar:camera-outline'
                                            className='text-xl text-secondary-light'
                                        ></iconify-icon>
                                        <span className='fw-semibold text-secondary-light'>
                                            Upload
                                        </span>
                                        <input
                                            id='upload-file'
                                            type='file'
                                            hidden
                                            accept='image/*'
                                            onChange={handleFileChange}
                                        />
                                    </label>
                                )}
                            </div>
                        </div>



                        <div className="col-12">
                            <button onClick={handleAddNewSubCategory} className="btn btn-primary-600">
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddNewSubCategory